import React, { useContext } from 'react';
import { PeopleContext } from './context/PeopleContex';
import RemoveIcon from './img/RemoveIcon.svg';
import './App.css';

function DisplayData({ dataToDisplay }) {
  const { deletePerson } = useContext(PeopleContext);

  return (
    <section>
      {dataToDisplay.map((person) => (
        <article key={person.id} className="personContainer">
          <div className="displayFlex">
            <h2>{person.fullName}</h2>
            <img
              src={RemoveIcon}
              className="icon"
              alt="delete item"
              onClick={() => deletePerson(person.id)}
            />
          </div>
          <div className="personInformation">
            <p>
              <strong>Birth date:</strong> {person.dateOfBirth || 'undefined'}
            </p>
            <p>
              <strong>Tags:</strong> {person.tags.map((tag) => `${tag} `)}
            </p>
            <p>
              <strong>Note:</strong> {person.note}
            </p>
          </div>
        </article>
      ))}
    </section>
  );
}

export default DisplayData;
